// Два режима выбора адреса бэкенда, переключаются флагом REACT_APP_USE_ORIGIN
// из .env (не кодом):
//   не задан / 'false' -> адрес берётся из REACT_APP_API_URL/REACT_APP_WSS_URL
//                         (локальный .env, .env.development и т.д.)
//   'true'             -> адрес берётся из window.location.origin — того же
//                         домена, с которого открыт кабинет. Нужно для сборок,
//                         которые должны работать на любом сервере без
//                         привязки к конкретному хосту в .env.
// NODE_ENV тут не индикатор окружения — в обоих Dockerfile'ах он жёстко
// прописан как `production` (так того требует сборка react-scripts), поэтому
// прод от дев-сервера по нему не отличить. Переключайте через сам .env-файл,
// который попадает в сборку (локальный .env, .env.development, .env.production
// — они не лежат в репозитории, держите их там, откуда собирается образ):
// пропишите REACT_APP_USE_ORIGIN=true там, где нужен режим "домен по месту".
const useOrigin = process.env.REACT_APP_USE_ORIGIN === 'true';
const baseURL = typeof window !== 'undefined' ? window.location.origin : '';

// ---- Локализация ----
// Базовый язык интерфейса: 'ru', 'en' или 'bg'.
// Если переводы включены, он используется при отсутствии сохранённого выбора.
// Если переводы выключены, весь интерфейс принудительно отображается на этом языке.
export const DEFAULT_LANGUAGE = 'ru';

// true  — пользователь может менять язык, переключатели отображаются;
// false — переключатели скрыты на входе, регистрации, в Header и боковом меню,
//         а приложение всегда использует DEFAULT_LANGUAGE.
export const TRANSLATIONS_ENABLED = false;

export { MARKETING_MATERIALS, getMarketingMaterialImage } from './marketingMaterials';

export const API_URL = useOrigin
  ? baseURL + process.env.REACT_APP_PATH_URL
  : process.env.REACT_APP_API_URL + process.env.REACT_APP_PATH_URL;

export const WS_API_URL = useOrigin
  ? baseURL.replace(/^http(s)?:\/\//, 'wss://') + process.env.REACT_APP_PATH_URL
  : process.env.REACT_APP_WSS_URL + process.env.REACT_APP_PATH_URL;

// Версия клиента, уходит заголовком xcvid в каждом запросе. Бэкенд сверяет её
// строго как строку и при несовпадении отвечает 426 (кабинет перезагрузится).
export const CLIENT_VERSION = '2025122408';

// Продукты, скрытые из каталога (недоступны к покупке).
export const BLOCKED_PRODUCT_NAMES = [
  'GT Bentayga+',
  'GT Bentayga',
  'GT Vantage',
  'GT Vantage+',
  'GT Tiger',
  'GT Tiger+',

  'FT Crystal K',
  'FT Crystal R',
  'FT Crystal A',
  'FT Atlant K',
  'FT Atlant R',
  'FT Atlant A',
  'FT Virage K',
  'FT Virage R',
  'FT Virage A',

  'FT King K',
  'FT King R',
  'FT King A',
  'Канал с сигналами',
  'FT Metall',
  'FT Metall+',
  'FT Atlant A☆☆',
  'FT Virage A☆☆',
  'FT Crystal A☆☆',
  'FT Zagato',
  'FT Academy Crypto Start',
  'FT Vector',
  'FT Pilot K',
  'FT Pilot R',
  'FT Pilot A',

  'FT Cayman Black',
];

// Минимальный срок техподдержки в корзине, мес. (меньше выбрать нельзя).
export const TECH_SUPPORT_MIN_MONTHS = 6;

// Монеты и сети для ручной оплаты (перевод на кошелёк + чек).
// Ключ — монета, значение — список доступных для неё сетей. В выбор попадут
// только те сети, которые бэкенд реально отдаёт в /cart/get_payment_methods
// (methods[manual].networks), так что включить новую сеть нужно и тут, и на бэке.
export const MANUAL_PAYMENT_NETWORKS_BY_COIN = {
  USDT: ['TRC-20', 'BEP-20', 'ERC-20'],
  USDC: ['ERC-20'],
};

// ---- Ссылки ----
export const TELEGRAM_REDIRECT_BASE = 'https://tlgg.ru/';

export const LINKS = {
  // Поддержка
  supportTelegram: 'https://t.me/Mr_support_golden',
  supportTelegramRedirect: `${TELEGRAM_REDIRECT_BASE}@Mr_support_golden`,
  // Соцсети и каналы
  instagram: 'https://www.instagram.com/general_trader_group/',
  youtubeChannel: 'https://www.youtube.com/channel/UCiS6Cm2q4Zzdyh61wpXJ4vg',
  supportPageTelegramChannel: 'https://t.me/+f-eGifHGXeAzYWQy',
  controlTelegram: 'https://t.me/gtgcontrol',
  mainTelegramChannel: 'https://t.me/+N14IKByfHyFiYWYy',
  academyTelegram: 'https://t.me/+XNJ5YAMQvuUwYjgy',
  // Видео-инструкция по активации продукта
  activationVideo: 'https://www.youtube.com/watch?v=DWkUQHs-EII',
  // Промо-материалы партнёров
  promoPresentations: 'https://disk.yandex.ru/d/TFK7M-nWaio51g',
  promoVideo: 'https://disk.yandex.ru/d/U5QYSiOP8XYN0g',
  promoPhoto: 'https://disk.yandex.ru/d/l1avbRNXREorag',
  promoReviews: 'https://t.me/ftholdingreviews',
  promoRun: 'https://disk.yandex.ru/d/FWpaWFJNcHaWEA',
};

// Ссылка на Telegram наставника; если его нет — на поддержку.
export const getTelegramLink = (username) =>
  username ? `${TELEGRAM_REDIRECT_BASE}${username}` : LINKS.supportTelegramRedirect;

// ---- Консоль браузера ----
// true — в консоли остаются только ошибки (красные), а log/info/warn/debug глушатся.
// false — выводится всё как обычно.
export const CONSOLE_ONLY_ERRORS = true;

// ---- Интервалы и лимиты ----
export const NOTIFICATIONS_POLL_INTERVAL_MS = 30000; // как часто опрашивать уведомления
export const NOTIFICATIONS_PAGE_LIMIT = 20; // сколько уведомлений грузить за раз
export const TRANSACTIONS_PAGE_SIZE = 10; // размер страницы истории операций
export const WS_BALANCE_RECONNECT_MAX_ATTEMPTS = 3; // попыток переподключения WS баланса
export const WS_QUOTES_RECONNECT_MAX_ATTEMPTS = 5; // попыток переподключения WS котировок
export const BILL_UPLOAD_CHUNK_SIZE = 64 * 1024; // размер части при загрузке чека, байт
// Защита от бесконечных перезагрузок при ошибках (иначе бэкенд банит как DDoS):
// не больше RELOAD_GUARD_MAX_ATTEMPTS перезагрузок за RELOAD_GUARD_WINDOW_MS.
export const RELOAD_GUARD_WINDOW_MS = 10000;
export const RELOAD_GUARD_MAX_ATTEMPTS = 2;

// ---- Подписка на сигналы ----
// Доступные сроки в карточке (мес.). Набор должен совпадать с тем, что принимает бэкенд.
export const SIGNALS_MONTHS_OPTIONS = [1, 3, 6, 12];

// Минимальный срок подписки, мес. (и срок при первом добавлении в корзину). Дальше срок меняется по одному
// месяцу (как у техподдержки), верхней границы нет.
export const SIGNALS_MIN_MONTHS = 6;

// Срок, на который подписка попадает в корзину кнопкой «Добавить в корзину» / «Оплатить» на карточке продукта.
export const SIGNALS_DEFAULT_MONTHS = 6;

// Где показывать блок «Сигналы» (карточки подписки) в каталоге продуктов:
//   'top'    — самым первым, выше торговых систем;
//   'bottom' — в самом низу страницы;
//   'hidden' — не показывать вообще.
export const SIGNALS_BLOCK_POSITION = 'bottom';

// Где показывать карточку своей подписки («FT Trade Signals», статус, привязка
// Telegram) в «Купленных продуктах»:
//   'top'    — внутри общего блока, сразу под «Технической поддержкой»;
//   'bottom' — отдельной панелью в самом низу страницы;
//   'hidden' — не показывать вообще.
export const SIGNALS_SUBSCRIPTION_POSITION = 'top';

// ---- Названия категорий продуктов (приходят с бэкенда, сравниваются как строки) ----
// Название продукта-подписки на сигналы. В «Купленных продуктах» она показывается
// строкой в панели «Сигналы», а не отдельной позицией списка;
// остальные продукты этой категории (например, FT Vector) показываются как обычно.
export const SIGNALS_SUBSCRIPTION_PRODUCT_NAME = 'FT Trade Signals';

export const PRODUCT_CATEGORIES = {
  techSupport: 'Техническая поддержка',
  signals: 'Сигналы',
  server: 'FT Server',
};

// ---- VPS-серверы ----
// Сколько дней после окончания срока ждём оплату, потом сервер и данные удаляются.
// Показывается клиенту в карточке сервера со статусом «Подписка истекла». Должно
// совпадать с SERVER_KEEP_DAYS_AFTER_EXPIRE на бэкенде.
export const SERVER_KEEP_DAYS_AFTER_EXPIRE = 7;

// ---- Оплата ----
// Минимальная сумма покупки (в USD), ниже неё оплата из корзины недоступна.
export const MIN_PURCHASE_AMOUNT = 10;

// ---- Вывод средств ----
// Монеты и сети для вывода: ключ — монета, значение — доступные для неё сети.
export const WITHDRAW_NETWORKS_BY_COIN = {
  USDT: ['TRC-20', 'BEP-20', 'ERC-20'],
  USDC: ['ERC-20'],
};
// Минимальная сумма вывода (целое число, в USDT).
export const WITHDRAW_MIN_AMOUNT = 75;

// Какой способ использовать как "оплата криптовалютой" в корзине:
// 'coinsbuy' — редирект на платёжную страницу Coinsbuy (монету/сеть клиент выбирает там);
// 'manual'   — старый способ: перевод на наш кошелёк + загрузка чека на подтверждение оператором.
// Бэкенд обязан держать включённым (enabled: true в /cart/get_payment_methods) тот способ,
// что выбран здесь, иначе кнопка оплаты криптовалютой не покажется.
export const CART_CRYPTO_PAYMENT_METHOD = 'coinsbuy';

export const authPopupTypes = {
  registration: 'registration',
  confirmRegistration: 'confirmRegistration',
  login: 'login',
  reset: 'reset',
  confirmReset: 'confirmReset',
  successReset: 'successReset',
  confirmLogin: 'confirmLogin',
};

export const twoFactorAuthTypes = {
  choseType2FA: 'chose-type-2fa',
  confirmCode2FA: 'confirm-code-2fa',
};

export const accountStatisticsHistoryTypeTypes = {
  personalSales: 'personal_money',
  teamSales: 'team_money',
  personalRegistry: 'personal_registry',
  teamRegistry: 'team_registry',
};

export const profileMainInfoTypes = {
  firstName: 'first_name',
  lastName: 'last_name',
  middleName: 'middle_name',
  birtdayTimestamp: 'birthday_timestamp',
  country: 'country',
  phone: 'phone',
  telegram: 'telegram',
};

export const changePasswordTypes = {
  verificationUserId: 'verification_user_id',
  verificationKey: 'verification_key',
  verification_type: 'verification_type',
  oldPassword: 'old_password',
  newPassword: 'new_password',
};

export const getPassportVerificationStatusTypes = {
  status: {
    noVerification: 0,
    inProccess: 1,
    verificated: 2,
    verificationError: 3,
  },
};

export const calculatorTypes = {
  compoundComponent: 'compoundComponent', // сложный процент
  closeMortgage: 'closeMortgage', // закрытие ипотеки
  vacation: 'vacation', // накопить на отпуск
  yearlyBuy: 'yearlyBuy', // ежегодная покупка
  buyCar: 'buyCar', // покупка машины
  calcPartner: 'calcPartner', // калькулятор партнера
  payEducation: 'payEducation', // оплата за обучение
  financeFreedom: 'financeFreedom', // финансовая свобода
};

export const calculatorIds = {
  compoundComponent: 'hard', // сложный процент
  closeMortgage: 'close', // закрытие ипотеки
  vacation: 'save', // накопить на отпуск
  yearlyBuy: 'buy', // ежегодная покупка
  buyCar: 'buy-2', // покупка машины
  calcPartner: 'calc', // калькулятор партнера
  payEducation: 'study', // оплата за обучение
  financeFreedom: 'free', // финансовая свобода
};
